import { autoinject } from 'aurelia-framework';

import { GenericApi } from '~/api/generic-api';
import { EntityType } from '~/models/entities/entity-type';
import { SearchResponse } from '~/models/search-response';
import { FetchUtils } from '~/utils/fetch-utils';

export interface AdviserSearchResult {
	entityType: EntityType.ADVISER;
	values: AdviserSearchValuesBackend;
	// NOTE: Jake: 2019-10-08
	// We can fill our fieldModel details later if they
	// came through
	// fieldModel?: undefined;
}

export interface AdviserResult {
	entityType: EntityType.ADVISER;
	values: AdviserValuesBackend;
}

interface AdviserSearchValuesBackend {
	BDz_Name: string;
	BDz_Business_Name: string;
}

// NOTE: Jake: 2019-10-08 - WEBUI-2548
// This might seem redundant, but the "get" endpoint might be extended in the future
// to return more fields (ie. like "MemberSearchResultBackend")
type AdviserValuesBackend = AdviserSearchValuesBackend;

@autoinject
export class AdviserSearchApi {
	private static readonly RESOURCE_PATH = 'api/adviser';

	public getSearchResults(
		query: string,
	): Promise<SearchResponse<AdviserSearchResult>> {
		return FetchUtils.getJSON<SearchResponse<AdviserSearchResult>>(
			AdviserSearchApi.RESOURCE_PATH + '/search',
			{
				q: query,
				'field-model': true,
			},
		).then((response) => {
			for (const item of response.data) {
				item.entityType = EntityType.ADVISER;
			}
			return response;
		});
	}

	public getAdviser(name: string): Promise<AdviserResult> {
		return FetchUtils.getJSON<AdviserResult>(
			AdviserSearchApi.RESOURCE_PATH + '/' + name,
		).then((data) => {
			data.entityType = EntityType.ADVISER;
			return data;
		});
	}
}
